const ACTIVE_GOOGLE_MAPS_KEY = 'AIzaSyAfpxkAWJhls97k_eAkKtCUfMMvRR8feWs';
const DEPRECATED_KEYS = [
  'AIzaSyAWc019GOicO9fr8mzOlwNC2VlIjp-kzqg'
];

const envKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY.trim() : '';
const resolvedMapsKey = (envKey && !DEPRECATED_KEYS.includes(envKey)) ? envKey : ACTIVE_GOOGLE_MAPS_KEY;

const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.hubscroll.app',
  GOOGLE_MAPS_API_KEY: resolvedMapsKey
};


export default config;
